module.exports = __webpack_public_path__ + "static/media/welcomeDark.163034d9.png";